import { render, staticRenderFns } from "./HomeDetail.vue?vue&type=template&id=4b1f9d4b&scoped=true"
import script from "./HomeDetail.vue?vue&type=script&lang=js"
export * from "./HomeDetail.vue?vue&type=script&lang=js"
import style0 from "./HomeDetail.vue?vue&type=style&index=0&id=4b1f9d4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1f9d4b",
  null
  
)

export default component.exports